/* KENZ — script panier (bouton "accéder au panier" + réassurance tiroir + pop-up point relais) */
(function(){
  'use strict';
  var RELAIS_HTML = ''
    + '<div class="kenz-relais" id="kenzRelais" aria-hidden="true">'
    +   '<div class="kenz-relais__back" data-kenz-relais-close></div>'
    +   '<div class="kenz-relais__box" role="dialog" aria-modal="true" aria-labelledby="kenzRelaisTitle">'
    +     '<button type="button" class="kenz-relais__close" data-kenz-relais-close aria-label="Fermer">&times;</button>'
    +     '<div class="kenz-relais__ico"><svg viewBox="0 0 24 24"><path d="M12 2 3 7v10l9 5 9-5V7l-9-5Z"/><path d="M12 22V12M3 7l9 5 9-5"/></svg></div>'
    +     '<h3 id="kenzRelaisTitle">Avant de valider</h3>'
    +     '<p><b>Bon à savoir :</b> Économisez sur vos frais en optant pour une livraison en point relais (à sélectionner lors du paiement).</p>'
    +     '<p>En point relais, pensez à renseigner votre <b>numéro de téléphone</b> : il est obligatoire pour la commande.</p>'
    +     '<button type="button" class="kenz-relais__btn" id="kenzRelaisOk">J’ai compris</button>'
    +   '</div>'
    + '</div>';

  var BAG = '<svg viewBox="0 0 24 24"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  var LOCK = '<svg viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  var CHAT = '<svg viewBox="0 0 24 24"><path d="M12 4.5c4.4 0 8 2.8 8 6.2 0 3.5-3.6 6.3-8 6.3-1 0-2-.15-2.9-.42L5 18l.9-3.1C4.7 13.8 4 12.5 4 10.7c0-3.4 3.6-6.2 8-6.2Z"/><path d="M9 11h.01M12 11h.01M15 11h.01"/></svg>';

  var proceed = false;

  function closeCartDrawer(){
    var comp = document.querySelector('cart-drawer-component, cart-drawer');
    if (comp && typeof comp.close === 'function'){ try{ comp.close(); }catch(e){} }
    document.querySelectorAll('dialog[open]').forEach(function(d){ try{ d.close(); }catch(e){} });
    var x = document.querySelector('.cart-drawer .drawer__close, .cart-drawer button[aria-label*="ermer"], .cart-drawer [on\\:click*="close"]');
    if (x){ try{ x.click(); }catch(e){} }
    document.querySelectorAll('.cart-drawer, .drawer, [aria-modal="true"].cart-drawer').forEach(function(el){
      el.removeAttribute('open'); el.setAttribute('aria-hidden','true');
    });
    document.body.style.overflow='';
  }

  function ensureRelais(){
    var existing = document.getElementById('kenzRelais');
    if (existing){ document.body.appendChild(existing); return existing; }
    var wrap = document.createElement('div');
    wrap.innerHTML = RELAIS_HTML;
    var relais = wrap.firstChild;
    document.body.appendChild(relais);
    relais.addEventListener('click', function(e){
      if (e.target.hasAttribute('data-kenz-relais-close')) closeRelais();
    });
    relais.querySelector('#kenzRelaisOk').addEventListener('click', function(){
      proceed = true;
      closeRelais();
      var btn = document.querySelector('#checkout, button[name="checkout"]');
      if (btn) { btn.click(); }
      else { window.location.href = '/checkout'; }
    });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeRelais(); });
    return relais;
  }
  function openRelais(){
    closeCartDrawer();
    var r = ensureRelais();
    setTimeout(function(){ r.classList.add('is-open'); document.body.style.overflow='hidden'; }, 60);
  }
  function closeRelais(){ var r=document.getElementById('kenzRelais'); if(r) r.classList.remove('is-open'); document.body.style.overflow=''; }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('#checkout, button[name="checkout"]');
    if (!btn) return;
    if (proceed) { proceed = false; return; }
    e.preventDefault();
    e.stopPropagation();
    openRelais();
  }, true);

  // Habillage du tiroir : bandeau réassurance en haut, bouton "accéder au panier" + cadenas en bas
  function enhanceDrawer(){
    document.querySelectorAll('.cart-drawer .cart-items__wrapper').forEach(function(w){
      if (w.parentNode && w.parentNode.querySelector('.kenz-cart-top')) return;
      var bar = document.createElement('div');
      bar.className = 'kenz-cart-top';
      bar.innerHTML = '<span>'+LOCK+'Paiement sécurisé</span><i class="kenz-sep"></i><span>'+CHAT+'Service client réactif</span>';
      w.parentNode.insertBefore(bar, w);
    });
    document.querySelectorAll('.cart-drawer .cart__ctas').forEach(function(cta){
      if (!cta.querySelector('.kenz-cart-view')){
        var a = document.createElement('a');
        a.href = '/cart';
        a.className = 'kenz-cart-view';
        a.innerHTML = BAG + '<span>Accéder au panier</span>';
        cta.appendChild(a);
      }
      if (!cta.querySelector('.kenz-cart-secure')){
        var s = document.createElement('div');
        s.className = 'kenz-cart-secure';
        s.innerHTML = LOCK + '<span>Paiement 100% sécurisé · Données protégées</span>';
        cta.appendChild(s);
      }
    });
  }

  function init(){ enhanceDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  var mo = new MutationObserver(function(){ enhanceDrawer(); });
  mo.observe(document.body, { childList:true, subtree:true });
})();
